import React from "react";
import PropTypes from "prop-types";
import { List, AutoSizer } from 'react-virtualized';
import { isMobileOrTablet } from '../../lib/window';
//import AutoSizer from 'react-virtualized/dist/commonjs/AutoSizer' - improve bundle size
//import List from 'react-virtualized/dist/commonjs/List'

class TracksTable extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    const { songs, onClickSong, activePlaylistLoading } = this.props;

    function rowRenderer ({
      key,         // Unique key within array of rows
      index,       // Index of row within collection
      isScrolling, // The List is currently being scrolled
      isVisible,   // This row is visible within the List (eg it is not an overscanned row)
      style        // Style object to be applied to row (to position it)
    }) {
      const song = songs[index];
      const { songName, artistName, albumName, duration, popularity, preview } = song;
      return (
        <React.Fragment key={key}>
          <div
            style={style}
            className={ 'song' }
            onClick={() => { onClickSong(preview) } }
          >
            { songName } | { artistName } | { albumName } | { duration } | { popularity }
          </div>

          {/* --- STYLES --- */}
          <style jsx>{`
           .song {
              color: #282828;
              padding-left: 8px;
              font-size: 1.1em;
              padding-bottom: 5px;
              cursor: pointer;
              overflow-x: hidden;
              width: 100%;
              white-space: nowrap;
              text-overflow: ellipsis;

              :hover {
                font-weight: 600;
                color: black;
              }
            }
          `}</style>
        </React.Fragment>
      )
    }

    return (
      <React.Fragment>
        <div className="tracks-table">
          {!activePlaylistLoading &&
            <div className="tracks">
              {songs.length > 0 ?
                <AutoSizer>
                  {({height, width}) => {
                    return (<List
                      width={width}
                      height={height}
                      rowCount={songs.length}
                      rowHeight={isMobileOrTablet() > 1000 ? 30 : 35}
                      rowRenderer={rowRenderer}
                      style={{outline: 'none'}}
                    />);
                  }}
                </AutoSizer>
                :
                <div>No songs in playlist to display</div>
              }
            </div>
          }
        </div>

        {/* --- STYLES --- */}
        <style jsx>{`
         .tracks-table {
            background-color: white;
            height: 80%;
            color:  #cccccc;
            padding: 15px 0px;
            display: flex;
            flex-direction: column;

            .tracks {
              flex: 10;
              padding-bottom: 5px;
            }

            .head {
              flex: .5;
              color: white;
              margin-bottom: 15px;
              padding: 0px 15px;
            }
         }
        `}</style>
      </React.Fragment>
    );
  }
};

export default TracksTable;



// WEBPACK FOOTER //
// ./src/components/TracksTable/TracksTable.js